/**
 * Created by H
 * User: huangcan
 * Date: 2019-06-20
 * Time: 16:55
 * tips: table的一些基本操作
 */
import pagination from '../pagination'
import exportExcel from 'mixins/export/'

export default {
  data() {
    this.optionsTip = {
      cancelButtonText: '取消',
      showClose: false,
      cancelButtonClass: 'el-button--98',
      confirmButtonClass: 'el-button--98 sub-color',
      type: 'warning',
      center: true
    }
    return {
      multipleSelection: []
    }
  },
  mixins: [pagination, exportExcel],
  props: {
    styleTable: {
      type: Object,
      default: () => {
        return {
          header: 'theader-th',
          cell: 'tbody-td'
        }
      }
    },
    btn: {
      type: Boolean,
      default: true
    },
    tableHeight: {
      type: Number,
      default: 500
    }
  },
  methods: {
    /**
     * 批量操作列表项（删除、审核、上架下架）
     * @param tips
     * @param type
     * @param btnStr
     */
    handleSelectionDel(tips, type = 'tableData', btnStr = '确定') {
      const len = this.multipleSelection.length
      if (len === 0) {
        this.$notify({
          type: 'warning',
          title: '没选中任何记录！'
        })
        return
      }
      const str =
        typeof tips === 'string' && tips !== ''
          ? `${tips}${len}条记录`
          : `删除${len}条记录`
      const options = Object.assign(this.optionsTip, {
        confirmButtonText: btnStr
      })
      this.$confirm(str, '提示', options)
        .then(async () => {
          await this._multipleDel(tips)
          const refresh = (vm, type) => {
            const del = arr => {
              return arr.filter(v => {
                return this.multipleSelection.includes(v) === false
              })
            }
            if (type === 'tableData') {
              vm[type] = del(vm[type])
            } else {
              vm[type].tableData = del(vm[type].tableData)
            }
            this._setPaginationNewValue(vm, type)
          }
          if (this.type === 'pagination') {
            refresh(this, 'tableData')
            return
          }
          this._notifyEmit('', (vm, newValue, type) => {
            refresh(vm, type)
          })
        })
        .catch(() => {})
    },
    /**
     * 当行操作列表项（删除、审核、上架下架)
     * @param index
     * @param rows
     * @param tips
     * @param btnStr
     */
    handleDelete(index, rows, tips = '删除1条记录', btnStr) {
      const options = Object.assign(this.optionsTip, {
        confirmButtonText: btnStr || '删除'
      })
      this.$confirm(tips, '提示', options)
        .then(async () => {
          await this.delRows(rows)
          const refresh = (tableData, vm, type) => {
            tableData.splice(index, 1)
            this._setPaginationNewValue(vm, type)
          }
          if (this.type === 'pagination') {
            refresh(this.tableData, this, 'tableData')
            return
          }
          this._notifyEmit(index, (vm, newValue, type) => {
            const tableData = (vm[type] && vm[type].tableData) || vm.tableData
            refresh(tableData, vm, type)
          })
        })
        .catch(() => {})
    },
    /**
     * 多选
     * @param val
     */
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    /**
     * 删除设置表格分页新值
     * @param vm
     * @param type
     * @private
     */
    _setPaginationNewValue(vm, type) {
      const s = type !== 'tableData' ? vm[type] : vm
      const del = this.multipleSelection.length || 1
      if (s.pagination) {
        s.pagination.recordTotal = s.pagination.recordTotal - del
        s.pagination.pageTotal = Math.ceil(s.pagination.recordTotal / 10)
      }
    }
  }
}
